export const MAPPING_ADDRESS_FIELD_LABEL = "Cell address or range";

export const MAPPING_ADDRESS_FIELD_PLACEHOLDER = "C9, A1:B6, B6:B...";

export const MAPPING_ADDRESS_FIELD_TOOLTIP =
    "`...` extends to the end of the sheet's data (not the first empty cell). Examples: B6:B... (column), B6:...6 (row), B6:... (sheet data).";
